import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_FreeTag = _resolveComponent("FreeTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "pb-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "d-flex align-center justify-end" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_add_icon, {
              size: "x-small",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tagDialog = true))
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdPartyCompanyTags, (thirdPartyCompanyTag, index) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    class: _normalizeClass(
                            !_ctx.$vuetify.display.mobile
                                ? 'mb-2 oss-list-item rounded-lg'
                                : 'mb-2 px-2 oss-list-item rounded-lg'
                        ),
                    key: index
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { color: "secondary" }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode(" $label_outline ")
                        ])),
                        _: 1
                      })
                    ]),
                    append: _withCtx(() => [
                      _createVNode(_component_v_btn_trash, {
                        onClick: ($event: any) => (_ctx.deleteTagRule(thirdPartyCompanyTag))
                      }, null, 8, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.tagTitle(thirdPartyCompanyTag)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["class"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.tagDialog)
      ? (_openBlock(), _createBlock(_component_FreeTag, {
          key: 0,
          inDialog: _ctx.tagDialog,
          "onUpdate:inDialog": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tagDialog) = $event)),
          companyTags: _ctx.allCompanyTags,
          company: _ctx.selectedCompany,
          createIfMissing: true,
          onOnTagsChanged: _ctx.onTagsChanged
        }, null, 8, ["inDialog", "companyTags", "company", "onOnTagsChanged"]))
      : _createCommentVNode("", true)
  ]))
}